import React from "react";
import { Globe, Check } from "lucide-react";
import {
    DropdownMenu,
    DropdownMenuTrigger,
    DropdownMenuContent,
    DropdownMenuItem,
} from "@/components/ui/dropdown-menu";
import { useLang } from "@/contexts/LanguageContext";
import { LANGS } from "@/lib/i18n";

export const LanguageSelector = () => {
    const { lang, setLang } = useLang();
    const current = LANGS.find((l) => l.code === lang) || LANGS[0];

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <button
                    type="button"
                    data-testid="language-selector"
                    className="inline-flex items-center gap-1.5 h-10 px-3 rounded-xl border border-[#E5E5E5] bg-white text-[13.5px] font-medium text-[#1F1F1F] hover:border-[#1B5E20] transition-colors"
                >
                    <Globe className="h-4 w-4 text-[#1B5E20]" />
                    {current.native}
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="bg-white min-w-[170px]">
                {LANGS.map((l) => (
                    <DropdownMenuItem
                        key={l.code}
                        data-testid={`language-option-${l.code}`}
                        onClick={() => setLang(l.code)}
                        className={`cursor-pointer flex items-center justify-between ${
                            l.code === lang ? "font-semibold text-[#1B5E20]" : ""
                        }`}
                    >
                        <span>
                            {l.native}
                            {l.code !== "en" && (
                                <span className="ml-1.5 text-[#777] text-xs">{l.label}</span>
                            )}
                        </span>
                        {l.code === lang && <Check className="h-4 w-4 text-[#1B5E20]" />}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
